import { Banner } from "@visioni/a3s-ui/components";
import { useImpersonationStore } from "../impersonation-store";

export interface ImpersonatedSettingsBannerProps {
  /** What the page edits, as it reads after "You are viewing Jane's" — e.g. "notification preferences". */
  readonly settings: string;
}

/**
 * Tells a support user that the settings on this page belong to the user they
 * are impersonating, and saving changes that user's account. Renders nothing
 * when not impersonating.
 */
export function ImpersonatedSettingsBanner({ settings }: ImpersonatedSettingsBannerProps) {
  const impersonatedLabel = useImpersonationStore((state) => state.impersonatedLabel);
  if (impersonatedLabel === null) return null;

  return (
    <Banner
      variant="warning"
      title={`You are viewing ${impersonatedLabel}'s ${settings}.`}
      message={`Editing their ${settings} will apply the changes to their account, not yours.`}
    />
  );
}
